import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { TipoUniversoService } from "src/app/services/tipo-universo.service";
import { ITipoUniversoModel } from "src/app/models/tipo-universo.model";
import Swal from "sweetalert2";

@Component({
	selector: "app-imprimir-tipo-universo-auditavel",
	templateUrl: "imprimir-universo-auditavel.component.html",
	styleUrls: ["imprimir-universo-auditavel.component.scss"],
})
export class ImprimirTipoUniversoAuditavelComponent implements OnInit {
	public dados: ITipoUniversoModel;
	public dataHoje = new Date();

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private tipoUniversoService: TipoUniversoService,
		public authService: AuthService
	) {}

	ngOnInit(): void {
		const id = Number(this.route.snapshot.paramMap.get("id"));
		if (id) {
			this.tipoUniversoService
				.imprimir(id)
				.then((res) => {
					this.dados = res.dados;
					if (this.dados.ugs && this.dados.ugs.length > 0) {
						if (this.dados.tipo === 1) {
							this.gerarNumeracao(this.dados.ugs);
						} else {
							this.dados.ugs.forEach((ug) => {
								if (ug.itens && ug.itens.length > 0) {
									this.gerarNumeracao(ug.itens);
								}
							});
						}
					}
				})
				.catch((err) => {
					Swal.fire({
						toast: true,
						position: "top-end",
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
						icon: "error",
						title: "Erro",
						text:
							err?.mensagem?.descricao ||
							"Erro ao carregar dados",
					});
					this.router.navigate(["/tipo-universo-auditavel"]);
				});
		}
	}

	private gerarNumeracao(itens: any[], prefixo: string = "") {
		itens.forEach((item, index) => {
			const numeroAtual = prefixo
				? `${prefixo}.${index + 1}`
				: `${index + 1}`;
			item.numero = numeroAtual;
			if (item.itens && item.itens.length > 0) {
				this.gerarNumeracao(item.itens, numeroAtual);
			}
		});
	}

	print(): void {
		window.print();
	}

	public cancelar(): void {
		this.router.navigate(["/tipo-universo"]);
	}
}
